import { twMerge } from 'tailwind-merge';
import { useTabsPanelContext } from './Tabs';

type TabsVerticalProps = {
  children: React.ReactNode;
  className?: string;
};
const TabsContainer = ({ children, className }: TabsVerticalProps) => {
  const { orientation } = useTabsPanelContext();

  return (
    <div
      className={twMerge(
        `relative flex h-fit w-full`,
        orientation === 'vertical' ? 'flex-row mb-14' : 'flex-col',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default TabsContainer;
